<template>
  <div>
    <template v-if="this.$route.meta && this.$route.meta.loadable">
      <template v-if="$wait.is(event)"> 
        <!-- loading {{ event }}  -->
      </template>
      <template v-else>
        <slot name="default"></slot>
      </template>
    </template>
    <template v-else>
      <slot name="default"></slot>
    </template>
  </div>
</template>

<script>
  import { PAGE_LOADING_EVENT } from '@shared/mixins/page-loadable';

  export default {
    data() {
      return {
        event: PAGE_LOADING_EVENT
      };
    },
    created() {
      if (this.$route.meta && this.$route.meta.loadable) {
        this.startLoadingPage();
      }
    }
  };
</script>
